import scheduleData from '../../data/fullSchedule.json'
import React, { useRef, useCallback } from 'react';
import * as htmlToImage from 'html-to-image';

const AISymposiumSchedule = ({ scheduleData, eventName = "AI Uni Conference" }) => {
  const a4Style = {
    // width: '794px',
    width: '60%',
    minHeight: '1123px',
  };

  const DaySchedule = ({ dayData, pageNumber }) => (
    <div 
      className="bg-gradient-to-br from-slate-900 via-blue-900/20 to-slate-900 mx-auto my-4 shadow-2xl border-none border-cyan-500/10 relative overflow-hidden"
      style={a4Style}
    >
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 25% 25%, #06b6d4 2px, transparent 2px)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 p-12">
        {/* Elegant Header */}
        <div className="text-center mb-6 pb-8 border-b border-cyan-500/20">
          <div className="inline-block">
            {/* <div className="w-16 h-1 bg-gradient-to-r from-cyan-400 to-emerald-400 mx-auto mb-4 rounded-full"></div> */}
            <h1 className="text-4xl font-semibold text-green-400 mb-0 tracking-wide">{eventName}</h1>
            {/* <div className="w-16 h-1 bg-gradient-to-r from-emerald-400 to-cyan-400 mx-auto mt-4 rounded-full"></div> */}
          </div>
          <h2 className="text-2xl font-light text-cyan-300/80 mt-4">{dayData.date}</h2>
          <div className="text-sm text-cyan-400/50 mt-2 font-mono">Day {pageNumber}</div>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical timeline line */}
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gradient-to-b from-cyan-400/20 via-cyan-400/40 to-cyan-400/20"></div>
          
          <div className="space-y-8">
            {dayData.schedule.map((item, index) => (
              <ScheduleItem key={index} item={item} index={index} />
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-cyan-500/10 text-center">
          <p className="text-cyan-400/60 text-sm font-light tracking-wide">National Symposium on AI • CVS, DU • New DELHI</p>
        </div>
      </div>
    </div>
  );

  const ScheduleItem = ({ item, index }) => {
    const isHighlight = item.id || (item.title && (
      item.title.includes('Plenary') || 
      item.title.includes('Technical') || 
      item.title.includes('Panel') ||
      item.title.includes('Session')
    ));
    
    const isMinor = item.title && (
      item.title.includes('Registration') ||
      item.title.includes('Lunch') ||
      item.title.includes('Coffee') ||
      item.title.includes('Break') ||
      item.title.includes('Inauguration') ||
      item.title.includes('Vote of Thanks') ||
      item.title.includes('Felicitation')
    );

    if (isMinor) {
      return (
        <div className="flex items-start group">
          {/* Timeline dot */}
          <div className="relative z-10 flex-shrink-0 w-12 h-12 flex items-center justify-center">
            <div className="w-3 h-3 bg-cyan-400/20 rounded-full group-hover:bg-cyan-400/60 transition-all duration-300"></div>
          </div>
          
          {/* Content */}
          <div className="flex-1 ml-8 -mt-1">
            <div className="bg-cyan-800/20 backdrop-blur-sm rounded-lg p-4 border-none border-cyan-500/5 hover:border-cyan-500/10 transition-all duration-300">
              <div className="text-center flex items-center justify-between w-full">
                <span className="text-cyan-400 text-xs font-semibold font-mono tracking-wide bg-cyan-400/5 px-3 py-1 rounded-full">
                  {item.time}
                </span>
                <h3 className="text-slate-100 text-sm mt-0 font-semibold tracking-wide">{item.title}</h3>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-start group">
        {/* Timeline dot */}
        <div className="relative z-10 flex-shrink-0 w-12 h-12 flex items-center justify-center">
          <div className={`w-4 h-4 rounded-full ${
            isHighlight 
              ? 'bg-gradient-to-r from-cyan-400 to-emerald-400 shadow-lg shadow-cyan-400/20' 
              : 'bg-cyan-400/40'
          } group-hover:scale-125 transition-transform duration-300`}></div>
        </div>
        
        {/* Content */}
        <div className="flex-1 ml-8 -mt-1">
          <div className={`bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-sm rounded-2xl p-4 border transition-all duration-500 hover:scale-[1.02] ${
            isHighlight 
              ? 'border-cyan-500/20 shadow-2xl shadow-cyan-500/10 hover:shadow-cyan-500/20' 
              : 'border-cyan-500/10 shadow-lg shadow-blue-500/5'
          }`}>
            
            {/* Time and Title */}
            <div className="flex items-center justify-between mb-0">
              <span className={`font-mono text-sm px-4 py-2 rounded-full ${
                isHighlight 
                  ? 'bg-cyan-400/10 text-cyan-300 border border-cyan-400/20' 
                  : 'bg-slate-700/30 text-slate-300 font-bold'
              }`}>
                {item.time}
              </span>
              <h3 className={`text-right max-w-lg ml-6 leading-tight ${
                isHighlight 
                  ? 'text-2xl font-light bg-gradient-to-r from-cyan-100 to-emerald-100 bg-clip-text text-transparent' 
                  : 'text-md text-slate-200 font-semibold'
              }`}>
                {item.title}
              </h3>
            </div>

            {/* Venue and Theme */}
            {(item.venue || item.theme) && (
              <div className="my-3 space-y-1">
                {item.theme && (
                  <p className="text-emerald-300/80 text-md flex items-center">
                    <span className="w-2 h-2 bg-emerald-400 rounded-full mr-3"></span>
                    {item.theme}
                  </p>
                )}
                {item.venue && (
                  <p className="text-cyan-300/80 text-sm flex items-center">
                    {/* <span className="w-2 h-2 bg-cyan-400 rounded-full mr-3"></span> */}
                    Venue: {item.venue}
                  </p>
                )}
              </div>
            )}

            {/* People */}
            {item.people && item.people.length > 0 && (
              <div className="mt-2">
                <div className="grid grid-cols-1 gap-3">
                  {item.people.map((person, idx) => (
                    <div key={idx} className="flex items-center text-sm">
                      <span className="text-cyan-400/90 font-bold min-w-20 tracking-wide">{person.type}:</span>
                      <span className="text-slate-100 ml-3 font-light">{person.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Session Details Grid */}
            {item.sessionDetails && (
              <div className="mt-2">
                <div className="grid grid-cols-1 gap-2">
                  {item.sessionDetails.map((session, idx) => (
                    <div key={idx} className="bg-cyan-800/40 rounded-xl p-3 border-none border-cyan-500/10 hover:border-cyan-500/20 transition-all duration-300">
                      <div className="flex justify-between items-start mb-3">
                        <span className="text-cyan-300 font-mono font-semibold text-xs bg-cyan-400/10 px-3 py-1.5 rounded-full">
                          {session.time}
                        </span>
                        {session.index && (
                          <span className="text-xs bg-emerald-400/10 text-emerald-300 px-3 py-1.5 rounded-full font-light">
                            Speaker {session.index}
                          </span>
                        )}
                      </div>
                      
                      {session.speaker && (
                        <p className="text-slate-200 text-sm font-semibold mb-1 leading-relaxed">
                          {session.speaker}
                        </p>
                      )}
                      
                      {session.topic && (
                        <p className="text-cyan-100/90 text-sm font-light italic leading-relaxed">
                          {session.topic}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Presentation List */}
            {/* {item.sessionDetails && item.sessionDetails.some(s => s.speaker && s.topic) && (
              <div className="mt-6">
                <div className="flex items-center mb-4">
                  <div className="w-4 h-0.5 bg-gradient-to-r from-cyan-400 to-emerald-400 mr-3"></div>
                  <h4 className="text-cyan-300 font-light text-sm tracking-wide">PRESENTATIONS</h4>
                </div>
                <div className="grid grid-cols-1 gap-2">
                  {item.sessionDetails
                    .filter(session => session.speaker && session.topic)
                    .map((session, idx) => (
                      <div key={idx} className="bg-slate-800/20 rounded-lg p-3 border border-slate-700/30 hover:border-cyan-500/10 transition-all duration-300">
                        <p className="text-slate-300 text-xs font-light leading-relaxed">
                          <span className="text-cyan-300 font-normal">
                            {session.speaker.split('--')[0]?.trim() || session.speaker.split('-')[0]?.trim()}:
                          </span>
                          {" "}{session.topic}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    );
  };

    const domEl = useRef(null);

  const downloadImage = useCallback(async () => {
    if (domEl.current) {
      try {
        // 2. Convert the DOM element to a data URL (PNG format)
        const dataUrl = await htmlToImage.toPng(domEl.current);

        // 3. Create a temporary anchor link for downloading
        const link = document.createElement('a');
        link.download = 'downloaded-image.png'; // Set the download file name
        link.href = dataUrl;

        // 4. Programmatically click the link to trigger the download
        link.click();
      } catch (err) {
        console.error('oops, something went wrong!', err);
      }
    }
  }, []);


  return (
    <div className="bg-gradient-to-br from-slate-900 via-blue-900/10 to-slate-900 min-h-screen py-8">
      {/* Elegant Notice */}
      <div className="no-print p-6 text-center mb-8">
        <div className="inline-block bg-gradient-to-r from-cyan-500/10 to-emerald-500/10 p-px rounded-2xl">
          <div className="bg-slate-900/80 backdrop-blur-sm px-8 py-4 rounded-2xl">
            <p className="text-cyan-300/80 font-light tracking-wide text-sm">
              AI CONFERENCE SCHEDULE • OPTIMIZED FOR A4 PRINTING
            </p>
            <button onClick={downloadImage} style={{ marginTop: '10px' }}>
                Download as PNG
            </button>

          </div>
        </div>
      </div>

      <div ref={domEl} className="flex flex-col items-center">
        {scheduleData.map((dayData, index) => (
          <DaySchedule 
            key={index} 
            dayData={dayData} 
            pageNumber={index + 1} 
          />
        ))}
      </div>
      
      {/* Print Styles */}
      <style jsx>{`
        @media print {
          body {
            margin: 0;
            padding: 0;
            background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%) !important;
          }
          .no-print {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

// Usage component
const Schedule = () => {
  // Your JSON data would be imported here

  return (
    <AISymposiumSchedule 
      scheduleData={scheduleData} 
      eventName="National Symposium on Artificial Intelligence" 
    />
  );
};

export default Schedule;